import { render } from "./FormTimer.vue?vue&type=template&id=1ad8429f&lang=pug"
import script from "./FormTimer.vue?vue&type=script&lang=js"
export * from "./FormTimer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__